import { render, staticRenderFns } from "./CreateAffiliatePage.vue?vue&type=template&id=154f6304&scoped=true&"
import script from "./CreateAffiliatePage.vue?vue&type=script&lang=js&"
export * from "./CreateAffiliatePage.vue?vue&type=script&lang=js&"
import style0 from "./CreateAffiliatePage.vue?vue&type=style&index=0&id=154f6304&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154f6304",
  null
  
)

export default component.exports